import { render, staticRenderFns } from "./Year.vue?vue&type=template&id=3754f72c&scoped=true&lang=html&"
import script from "./Year.vue?vue&type=script&lang=js&"
export * from "./Year.vue?vue&type=script&lang=js&"
import style0 from "./Year.vue?vue&type=style&index=0&id=3754f72c&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3754f72c",
  null
  
)

export default component.exports